import { atom } from 'jotai';

export const productLocationsSearchTermAtom = atom<string>('');
productLocationsSearchTermAtom.onMount = (setAtom) => {
  return () => setAtom(productLocationsSearchTermAtom.init);
};

export const inSeasonSearchTermAtom = atom<string>('');
inSeasonSearchTermAtom.onMount = (setAtom) => {
  return () => setAtom(inSeasonSearchTermAtom.init);
};
